import PropTypes from 'prop-types';

import { Announcement, BookmarkIcon, Card, CloseLargeIcon, EditableTitle } from '@utilities';

import styles from './_index.module.scss';

const HeaderCard = ({ buildError, handleClose, headerIcon, label, name, setName }) => {
  const headerIconElement = headerIcon ? headerIcon : <BookmarkIcon />;
  return (
    <Card className={styles['header-card']}>
      <div className={styles['header-card-title']}>
        <div className={styles['header-card-icon']}>{headerIconElement}</div>
        <div className={styles['header-card-text-content']}>
          {buildError && <Announcement text={buildError} variant="error" />}
          <EditableTitle autoFocus onChange={setName} value={name} />
          <p>{`Select from the below prompts to define the focus of your ${label}.`}</p>
        </div>
        <button
          aria-label="Close pre-build modal"
          className={styles['header-card-close']}
          onClick={handleClose}
          type="button"
        >
          <CloseLargeIcon />
        </button>
      </div>
    </Card>
  );
};

HeaderCard.propTypes = {
  buildError: PropTypes.string,
  handleClose: PropTypes.func,
  headerIcon: PropTypes.node,
  label: PropTypes.string,
  name: PropTypes.string,
  setName: PropTypes.func,
};

export default HeaderCard;
